import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import styles from './ThemeToggle.module.css';

/**
 * ThemeToggle Component
 *
 * A dropdown selector to switch between available themes (dark, light, navy, brownie, ai-fantasy).
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 *
 * @example
 * <ThemeToggle />
 */
const ThemeToggle = ({ className = '', ...props }) => {
  const { theme, setTheme, availableThemes } = useTheme();

  // Map theme names to display labels and icons
  const themeConfig = {
    dark: { label: 'Dark', icon: '🌙' },
    light: { label: 'Light', icon: '☀️' },
    navy: { label: 'Navy', icon: '⚓' },
    brownie: { label: 'Brownie', icon: '🍫' },
    'ai-fantasy': { label: 'AI Fantasy', icon: '🤖' }
  };

  const handleThemeChange = (e) => {
    setTheme(e.target.value);
  };

  const classNames = [
    styles.toggle,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classNames} {...props}>
      <span className={styles.icon}>
        {themeConfig[theme]?.icon || '🎨'}
      </span>
      <select
        value={theme}
        onChange={handleThemeChange}
        className={styles.select}
        aria-label="Select theme"
      >
        {availableThemes.map(themeName => (
          <option key={themeName} value={themeName}>
            {themeConfig[themeName]?.label || themeName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ThemeToggle;
